import React from 'react';
import { Box } from '@mui/material';
import { KpiSimpleDto, KpiVisitasDto } from '../../../types/visitas';
import SimpleKpiCard from './SimpleKpiCard';
import VisitasProgressKpi from './VisitasProgressKpi';

interface PlanIndicadoresPanelProps {
  visitas?: KpiVisitasDto;
  cobranzas?: KpiSimpleDto;
  ventas?: KpiSimpleDto;
  entregas?: KpiSimpleDto;
  compact?: boolean;
}

const zeroSimple: KpiSimpleDto = { total: 0, avancePorcentaje: 0 };

const PlanIndicadoresPanel: React.FC<PlanIndicadoresPanelProps> = ({
  visitas,
  cobranzas = zeroSimple,
  ventas = zeroSimple,
  entregas = zeroSimple,
  compact = false,
}) => {
  const minWidth = compact ? 230 : 280;

  return (
    <Box
      sx={{
        minWidth,
        display: 'grid',
        gridTemplateColumns: compact ? '1fr' : { xs: '1fr', sm: 'repeat(2, minmax(120px, 1fr))' },
        gap: 0.75,
      }}
    >
      <VisitasProgressKpi value={visitas} />
      <SimpleKpiCard title="Cobranzas" total={cobranzas.total} avancePorcentaje={cobranzas.avancePorcentaje} />
      <SimpleKpiCard title="Ventas" total={ventas.total} avancePorcentaje={ventas.avancePorcentaje} />
      <SimpleKpiCard title="Entregas" total={entregas.total} avancePorcentaje={entregas.avancePorcentaje} />
    </Box>
  );
};

export default PlanIndicadoresPanel;
